import { render } from "./bidangPengendalianPencemaran.vue?vue&type=template&id=db76a420"
import script from "./bidangPengendalianPencemaran.vue?vue&type=script&lang=js"
export * from "./bidangPengendalianPencemaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__